<style>
    form{
        padding: 5% 5% 1% 5%;
    }
    form .active{
        background-color: transparent !important;
    }
</style>
<template>
    <div class="section">
        <div class="container">
            <h4 class="center-align brown-text">Faça já sua Reserva !</h4>
            <div class="row">
                <div class="col s12 m12 l12">
                    <form name="form" @submit.prevent="submit" class="brown lighten-5 z-depth-2 hoverable">
                        <div class="row">
                            <div class="input-field col s12">
                                <i class="material-icons prefix">account_circle</i>
                                <input id="nome" v-model="reserva.nome" type="text" class="validate" required="true">
                                <label for="nome">Nome</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <i class="material-icons prefix">email</i>
                                <input id="email" v-model="reserva.email" type="email" class="validate" required="true">
                                <label for="email">Email</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <i class="material-icons prefix">phone</i>
                                <input id="telefone" v-model="reserva.telefone" type="text" class="validate" required="true">
                                <label for="telefone">Telefone</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s6">
                                <i class="material-icons prefix">today</i>
                                <input id="dataentrada" v-model="reserva.dataentrada" type="date" class="sdatepicker" required="true">

                            </div>
                            <div class="input-field col s6">
                                <i class="material-icons prefix">today</i>
                                <input id="datasaida" v-model="reserva.datasaida" type="date" class="sdatepicker" required="true">

                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field col s12">
                                <i class="material-icons prefix">mode_edit</i>
                                <textarea id="mensagem" v-model="reserva.mensagem" class="materialize-textarea"></textarea>
                                <label for="mensagem">Mensagem</label>
                            </div>
                            <button class="btn waves-effect waves-light" name="action">Submit
                                <i class="material-icons right">send</i>
                            </button>
                        </div>
                    </form>
                    <div class="row">
                        <div class="right col s12 m3 l3">
                            <div class="card z-depth-2 brown lighten-5 hoverable">
                                <div class="card-content brown-text">
                                    <p><i class="small material-icons">phone</i>(33)3263-3883</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import {MailResource} from '../../js/main'
    export default {
        data(){
            return{
                reserva : {}
            }
        },
        mounted(){
            $('nav div ul').children().removeClass('active');
            $('.nav-reser').addClass('active');
        },
        methods: {
            submit() {
                let data = JSON.stringify(this.reserva);
                //console.log(data);
                MailResource.save({},data).then((response) => {
                    //console.log(response);
                    Materialize.toast(response.body, 4000);
                });
            }
        }
    };
</script>


// WEBPACK FOOTER //
// reservas.vue?41eb910a